import { getElements, ifSelectorExist } from './utils';

export const showMoreReviews = () => {
  const reviewItems = getElements('.text-reviews-block__item_description');

  reviewItems.forEach(item => {
    const reviewText = item.querySelector('.text-reviews-block__item__text');
    const showMoreButton = item.querySelector('.text-reviews-block__item_show_more');

    if (reviewText.scrollHeight > reviewText.clientHeight) {
      showMoreButton.addEventListener('click', function () {
        reviewText.classList.toggle('opened');
        showMoreButton.textContent = reviewText.classList.contains('opened') ? 'Show Less' : 'Show More';
      });
    } else {
      showMoreButton.style.display = 'none';
    }
  });
};
